export const countriesApi = {

    getAll () {
        return axios.get(`/api/country`)
    },

}
